import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { IOfflineSupplier } from 'src/types/OfflineSupplier';
import axiosInstance from 'src/utils/axios';

async function fetchOfflineSuppliers(): Promise<IOfflineSupplier[]> {
  const response = await axiosInstance.get<IOfflineSupplier[]>(api.getOfflineSuppliers);
  return response.data;
}

export interface UseOfflineSuppliersQueryOptions {
  enabled?: boolean;
}

export function useOfflineSuppliersQuery({ enabled = true }: UseOfflineSuppliersQueryOptions = {}) {
  return useQuery<IOfflineSupplier[]>({
    queryKey: queryKeys.supplier.offline(),
    queryFn: fetchOfflineSuppliers,
    enabled,
    select: (data) =>
      data.map((item) => ({
        ...item,
        rowId: `supplier-${item.offlineSupplierId}`,
        selected: false,
      })),
  });
}
